module.exports = __webpack_public_path__ + "img/meltme_1400.0ab9526a.jpg";